import { render, staticRenderFns } from "./CreateGroupSlidebar.vue?vue&type=template&id=3cf3099c"
import script from "./CreateGroupSlidebar.vue?vue&type=script&lang=js"
export * from "./CreateGroupSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports